module.exports = __webpack_public_path__ + "media/theme/banner-sp-b11d8554.png";